/**
 * 日期数量走势组件（曲线图）
 * zxw
 * 创建时间：2025-12-10
 */

import { useEffect } from 'react';
import { Chart } from '@antv/g2';
import { Skeleton } from 'antd';
import CNF from '../../../incs/Config.js';
import { isMobileDevice, NumberFormat } from '../../../incs/FunHelper.js';

const ChartLineDateCount = props => {
    const { children, id, title, subtitle, streamStatus } = props;

    const timestamp = new Date().getTime().toString();
    const chartId = `${id ? id : 'antv-g2-id'}.${timestamp}`;

    // 加载中显示默认图片
    if (streamStatus === 'loading') {
        return <Skeleton.Image active={true} />;
    }

    useEffect(() => {
        const chart = new Chart({
            container: chartId,
            autoFit: isMobileDevice,
        });

        chart.title({
            title: title,
            subtitle: subtitle,
        });

        // 格式化数据
        chart.data(JSON.parse(children));

        chart
            .line()
            .encode('x', 'date')
            .encode('y', 'count')
            .encode('shape', 'smooth')
            .scale('y', { independent: true })
            .scale('y', { nice: true })
            .scale('color', {
                range: CNF.swatches[CNF.currentSwatche],
            })
            .axis('x', { title: '日期', })
            .axis('y', {
                title: '数量',
                labelFormatter: (d) => NumberFormat(d),
            })
            // .animate('enter', {
            //     type: 'pathIn',
            //     duration: CNF.animateDuration + 1000,
            // },)
            .tooltip({
                items: [(d => ({
                    name: '数量',
                    value: NumberFormat(d.count),
                }))]
            })
            .style('lineWidth', 1)
            .style('stroke', global.THEMECOLOR);

        chart.render();

        return () => {
            chart.destroy();
        }
    }, []);

    return <div id={chartId}></div>

}

export default ChartLineDateCount;